import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  root: {
    cursor: 'pointer',
    userSelect: 'none',
    [theme.breakpoints.down('md')]: {
      maxHeight: '50px',
    },
  },
}));
